module.exports = __webpack_public_path__ + "02_long_gold.eadea99c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_long_gold.png
// module id = 5Xix
// module chunks = 0